export * from '@lskjs/log/bin/lsklog';
export { default } from '@lskjs/log/bin/lsklog';
